import { render, staticRenderFns } from "./DetalheCampanhaWhatsapp.vue?vue&type=template&id=40a460ce&scoped=true"
import script from "./DetalheCampanhaWhatsapp.vue?vue&type=script&lang=js"
export * from "./DetalheCampanhaWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DetalheCampanhaWhatsapp.vue?vue&type=style&index=0&id=40a460ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a460ce",
  null
  
)

export default component.exports